// Single source of truth for the app version.
// Bumped on every push (per project convention: +0.0.1 normal, +0.1.0 major).
// `prebuild` / `prestart` scripts copy this value into public/version.json so
// the running client can poll it and detect new deployments.
export const APP_VERSION = '3.55.3';
